module.exports = __webpack_public_path__ + "img/full3-min.7596f9e4.png";